const initialize = () => {
    
    // Add target _blank to all external links
    let selector = 'a[href^="http"]';
    selector += ':not([href^="https://www.svmic.com"])';
    selector += ':not([href^="https://svmic2024.foxfuellabs"])';
    selector += ':not([href^="https://foxfuelcms"])';

    $(selector).attr("target","_blank");

    // Ensure PDF links get target blank
    $('a[href$=".pdf"]').attr("target","_blank");

};

export default {
    initialize,
};